
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-links",
      function () {
        return require("private-next-pages/payment-links/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-links"])
      });
    }
  